import { KCommandBase, CommandEnv, NavState } from 'components/cmdk/cmdkTypes'

type CommandNavAction = (env: CommandEnv) => NavState | Promise<NavState>

export type KNavigate = KCommandBase & {
  setEnv?: CommandNavAction
  path?: string
}

export function toNavAction(this: KNavigate, env: CommandEnv) {
  const {
    controls: { navigate, close },
  } = env
  const { path, label, group, setEnv } = this

  const dest = path ?? group?.path ?? ''
  const send = (r: NavState) => navigate(dest, { [label]: r })
  // Not very clean, will be changed to pre- and post- steps.
  const addedEnv = setEnv?.(env) ?? { query: '' }

  return () => Promise.resolve(addedEnv).then(send).then(close)
}
